document.addEventListener('DOMContentLoaded', function () {
    console.log('Collection page script loaded');

    const filterPopup = document.getElementById('filterPopup');
    const openFilterPopup = document.getElementById('openFilterPopup');
    const closeFilterPopup = document.getElementById('closeFilterPopup');
    const applyFilterBtn = document.getElementById('applyFilterBtn');
    const locationDropdown = document.getElementById('locationDropdown');
    const locationCodeDropdown = document.getElementById('locationCodeDropdown');
    const productContainers = document.querySelectorAll('.product-item');
    const selectedLocationArea = document.getElementById('selectedLocationArea');
    const deliveryTypeText = document.getElementById('deliveryTypeText');

    const SelectedLocation = {
        "delivery": {
            "METRO-MANILA": [
                "<b>METRO-MANILA</b>",
                "• CAVITE",
                "• LAGUNA",
                "• BATANGAS",
                "• RIZAL",
                "• BULACAN"
            ],
            "METRO-CEBU": [
                "<b>METRO-CEBU</b>",
                "• CEBU CITY",
                "• LAPU-LAPU",
                "• MANDAUE",
                "• TALISAY",
                "• COMPOSTELA",
                "• CONSOLACION",
                "• CORDOVA",
                "• LILOAN"
            ]
        }
    };

    // Function to check if location selection is mandatory
    function isLocationSelectionRequired() {
        const selectedLocationCode = localStorage.getItem('selectedLocationCode');
        return !selectedLocationCode || selectedLocationCode === 'ALL';
    }

    // Function to check if locations are different
    function isLocationChanged(newLocation) {
        const currentLocation = localStorage.getItem('selectedLocationCode');
        return currentLocation && currentLocation !== newLocation && currentLocation !== 'ALL';
    }

    // Function to show the filter popup
    function showFilterPopup() {
        filterPopup.style.display = 'block';
    }

    // Function to hide the filter popup
    function hideFilterPopup() {
        // Only allow closing if a location is already selected
        if (!isLocationSelectionRequired()) {
            filterPopup.style.display = 'none';
        } else {
            // If no location is selected, show an alert
            alert('Please select a location before continuing.');
        }
    }

    if (openFilterPopup && closeFilterPopup && filterPopup) {
        openFilterPopup.addEventListener('click', () => {
            showFilterPopup();
        });

        closeFilterPopup.addEventListener('click', () => {
            // Check if location selection is required before allowing to close
            hideFilterPopup();
        });

        window.addEventListener('click', (event) => {
            if (event.target === filterPopup) {
                // Check if location selection is required before allowing to close
                hideFilterPopup();
            }
        });
    }

    locationDropdown.addEventListener('change', function () {
        const selectedType = locationDropdown.value;
        locationCodeDropdown.innerHTML = '';

        if (selectedType === 'ALL') {
            locationCodeDropdown.innerHTML = `<option value="ALL">Show All</option>`;
            locationCodeDropdown.disabled = true;
            deliveryTypeText.textContent = 'LOCATION';
        } else {
            locationCodeDropdown.disabled = false;
            const locations = SelectedLocation[selectedType];
            for (const region in locations) {
                locations[region].forEach(loc => {
                  if (loc === "<b>METRO-MANILA</b>" || loc === "<b>METRO-CEBU</b>"){
                    locationCodeDropdown.innerHTML += `<option value="${region}" class="active" >${loc}</option>`;
                  }else{
                    locationCodeDropdown.innerHTML += `<option value="${region}" >${loc}</option>`;
                  }
                });
            }
          
            deliveryTypeText.textContent = selectedType === 'delivery' ? 'LOCATION' : 'PICK UP TO';
        }
    });

    applyFilterBtn.addEventListener('click', function () {
        const selectedType = locationDropdown.value;
        const selectedLocationCode = locationCodeDropdown.value;
        const selectedLocationText = locationCodeDropdown.options[locationCodeDropdown.selectedIndex].text;
        
        // Prevent selection if no location is chosen
        if (selectedLocationCode === 'ALL' || !selectedLocationCode) {
            alert('Please select a specific location');
            return;
        }

        let hasVisibleProducts = false;
        let shouldClearCart = false;

        // Check if location has changed
        if (isLocationChanged(selectedLocationCode)) {
            shouldClearCart = true;
            alert('Your cart will be cleared as you changed delivery locations.');
        }

        productContainers.forEach(product => {
            const productTags = product.getAttribute('data-tags') ? product.getAttribute('data-tags').split(',') : [];
            const matchesLocation = (selectedLocationCode === 'ALL' || productTags.includes(selectedLocationCode));

            if (matchesLocation) {
                product.style.display = 'block';
                hasVisibleProducts = true;
            } else {
                product.style.display = 'none';
            }
        });

        const noResultsMessage = document.getElementById('noResultsMessage');
        if (noResultsMessage) {
            noResultsMessage.style.display = hasVisibleProducts ? 'none' : 'block';
        }

        localStorage.setItem('selectedLocationCode', selectedLocationCode);
        localStorage.setItem('selectedType', selectedType);
        localStorage.setItem('selectedLocationText', selectedLocationText);
        localStorage.setItem('locationSelectionMade', 'true');

        selectedLocationArea.textContent = selectedLocationText;
        hideFilterPopup();

        if (shouldClearCart) {
            clearCart();
        }
        
        // Update add to cart buttons after location change
        setTimeout(updateAddToCartButtons, 100);
    });

    function clearCart() {
        fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            return response.json();
        })
        .then(() => {
            console.log('All items removed from the cart.');
            window.location.reload();
        })
        .catch(error => {
            console.error('Error clearing the cart:', error);
        });
    }

    function applySavedFilters() {
        const savedLocationCode = localStorage.getItem('selectedLocationCode') || 'ALL';
        const savedType = localStorage.getItem('selectedType') || 'delivery';
        const savedLocationText = localStorage.getItem('selectedLocationText') || '';

        if (savedLocationCode) {
            // Load the appropriate dropdown options first
            if (savedType) {
                locationDropdown.value = savedType;
                locationDropdown.dispatchEvent(new Event('change'));
            }
            
            // Then try to set the location code
            if (locationCodeDropdown.querySelector(`option[value="${savedLocationCode}"]`)) {
                locationCodeDropdown.value = savedLocationCode;
            }
        }

        productContainers.forEach(product => {
            const productTags = product.getAttribute('data-tags') ? product.getAttribute('data-tags').split(',') : [];
            const matchesLocation = (savedLocationCode === 'ALL' || productTags.includes(savedLocationCode));

            product.style.display = matchesLocation ? 'block' : 'none';
        });

        selectedLocationArea.textContent = savedLocationText;
        deliveryTypeText.textContent = savedType === 'delivery' ? 'LOCATION' : 'LOCATION';
    }

    // Show filter popup if no location is selected on first visit
    if (isLocationSelectionRequired()) {
        showFilterPopup();
        
        // Set a default value in the location dropdown to make it easier for users
        if (locationDropdown.value === "" || !locationDropdown.value) {
            locationDropdown.value = "delivery";
            locationDropdown.dispatchEvent(new Event('change'));
        }
    }

    applySavedFilters();
    
    // Add event listener before page unload/navigation to enforce location selection
    window.addEventListener('beforeunload', function(e) {
        if (isLocationSelectionRequired() && filterPopup.style.display === 'block') {
            // Only trigger if the location popup is currently visible
            const message = 'Please select a location before leaving this page.';
            e.returnValue = message;
            return message;
        }
    });
    
    // Function to check if a product is available in the selected location
    function isProductAvailableInLocation(productTags) {
        const selectedLocationCode = (localStorage.getItem('selectedLocationCode') || 'ALL').trim();
        
        // If no location is selected or "ALL" is selected, show as unavailable
        if (selectedLocationCode === 'ALL' || selectedLocationCode === '') {
            return false; // Changed to false to prevent purchase without location selection
        }
        
        // Normalize tags to trimmed strings
        const tagsArray = Array.isArray(productTags)
            ? productTags
            : (typeof productTags === 'string' ? productTags.split(',') : []);
        const normalizedTags = tagsArray.map(tag => (tag || '').trim());
        
        // Check if the product's tags include the selected location code
        return normalizedTags.includes(selectedLocationCode);
    }

    // Function to get location-specific stock quantity for a product
    function getLocationStockQuantity(productElement) {
        const selectedLocationCode = (localStorage.getItem('selectedLocationCode') || 'ALL').trim();
        
        if (!productElement || selectedLocationCode === 'ALL' || selectedLocationCode === '') {
            return 0;
        }
        
        // Check if the product has the selected location tag
        const productTags = productElement.getAttribute('data-tags') || '';
        if (!isProductAvailableInLocation(productTags)) {
            return 0;
        }
        
        // Try to read per-variant stock from embedded JSON (on product page)
        const currentVariantId = getCurrentVariantId();
        if (currentVariantId) {
            const variantData = getVariantStockData(currentVariantId);
            if (variantData) {
                if (!variantData.available) {
                    return 0;
                }
                if (variantData.inventory_management && variantData.inventory_policy === 'deny') {
                    return variantData.inventory_quantity;
                }
                // If policy is 'continue' or no inventory management, allow purchase
                return -1;
            }
        }
        
        // Fallback: Try data-inventory-quantity attribute (used on product cards)
        const inventoryAttr = productElement.getAttribute('data-inventory-quantity');
        if (inventoryAttr !== null) {
            const qty = parseInt(inventoryAttr, 10);
            return isNaN(qty) ? -1 : qty;
        }
        
        // If product has the location tag but no specific stock data, allow (use Shopify default)
        return -1;
    }

    // Helper: Get the currently selected variant ID on the product page
    function getCurrentVariantId() {
        // Check the product form hidden input
        const formInput = document.querySelector('form[id^="product-form"] input[name="id"]:not([disabled])');
        if (formInput) return formInput.value;
        
        // Fallback: check URL params
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('variant');
    }

    // Helper: Read variant stock data from the embedded JSON block
    function getVariantStockData(variantId) {
        const scripts = document.querySelectorAll('script[id^="product-variant-stock-"]');
        for (const script of scripts) {
            try {
                const data = JSON.parse(script.textContent);
                if (data[variantId]) {
                    return data[variantId];
                }
            } catch (e) {
                console.warn('Failed to parse variant stock data:', e);
            }
        }
        return null;
    }

    // Function to get the maximum quantity that can be added to cart for a product
    function getMaxQuantityForProduct(productElement) {
        const locationStock = getLocationStockQuantity(productElement);
        
        // If locationStock is -1, use Shopify's default inventory
        if (locationStock === -1) {
            // Try to get Shopify's inventory quantity from data attribute
            const shopifyInventory = productElement.getAttribute('data-inventory-quantity');
            if (shopifyInventory !== null) {
                return parseInt(shopifyInventory, 10) || 999;
            }
            return 999; // Default high value if no inventory data
        }
        
        return locationStock;
    }

    // Function to update quantity selector max value based on location stock
    function updateQuantitySelectorMax(productElement) {
        const maxQuantity = getMaxQuantityForProduct(productElement);
        const quantityInput = productElement.querySelector('input[name="quantity"]');
        
        if (quantityInput) {
            if (maxQuantity > 0) {
                quantityInput.setAttribute('max', maxQuantity);
                // If current value exceeds max, reset to max
                if (parseInt(quantityInput.value, 10) > maxQuantity) {
                    quantityInput.value = maxQuantity;
                }
            } else if (maxQuantity === 0) {
                quantityInput.setAttribute('max', 0);
                quantityInput.value = 0;
            }
        }
    }

    // Function to validate quantity before adding to cart
    function validateQuantity(productElement, requestedQuantity) {
        const maxQuantity = getMaxQuantityForProduct(productElement);
        const selectedLocationCode = (localStorage.getItem('selectedLocationCode') || 'ALL').trim();
        const selectedLocationText = localStorage.getItem('selectedLocationText') || selectedLocationCode;
        
        if (selectedLocationCode === 'ALL' || selectedLocationCode === '') {
            return {
                valid: false,
                message: 'Please select a location before adding to cart.'
            };
        }
        
        if (maxQuantity === 0) {
            return {
                valid: false,
                message: `This product is not available in ${selectedLocationText}.`
            };
        }
        
        if (maxQuantity > 0 && requestedQuantity > maxQuantity) {
            return {
                valid: false,
                message: `Only ${maxQuantity} units available in ${selectedLocationText}.`,
                maxQuantity: maxQuantity
            };
        }
        
        return { valid: true };
    }

    // Function to update add to cart buttons visibility
    function updateAddToCartButtons() {
        const selectedLocationCode = localStorage.getItem('selectedLocationCode') || 'ALL';
        
        // If no location is selected, disable all add to cart buttons
        if (selectedLocationCode === 'ALL') {
            disableAllAddToCartButtons();
            return;
        }
        
        // Update product cards on collection pages
        document.querySelectorAll('product-card, .product-card').forEach(card => {
            const productTags = card.getAttribute('data-tags') || '';
            const quickBuyButtons = card.querySelectorAll('.product-card__quick-buy button');
            const isAvailable = isProductAvailableInLocation(productTags);
            
            quickBuyButtons.forEach(button => {
                if (!isAvailable) {
                    button.setAttribute('disabled', 'disabled');
                    button.classList.add('opacity-50', 'cursor-not-allowed');
                    button.setAttribute('title', 'Not available at your selected location');
                } else {
                    button.removeAttribute('disabled');
                    button.classList.remove('opacity-50', 'cursor-not-allowed');
                    button.removeAttribute('title');
                }
            });
        });
        
        // Update main product page buttons
        const productContainer = document.querySelector('.product');
        if (productContainer) {
            const productTags = productContainer.getAttribute('data-tags') || '';
            const isAvailable = isProductAvailableInLocation(productTags);
            const maxQuantity = getMaxQuantityForProduct(productContainer);
            
            // Find all add-to-cart type buttons
            const addToCartButtons = document.querySelectorAll(
                'buy-buttons button[type="submit"], button[type="submit"][form^="product-form"]'
            );
            const buyNowButton = document.querySelector('.shopify-payment-button button');
            
            // Update quantity selector max value
            updateQuantitySelectorMax(productContainer);
            
            // Update or create stock notice
            updateStockNotice(productContainer, maxQuantity, isAvailable);
            
            addToCartButtons.forEach(btn => {
                if (!isAvailable || maxQuantity === 0) {
                    btn.setAttribute('disabled', 'disabled');
                    btn.classList.add('opacity-50', 'cursor-not-allowed');
                } else {
                    btn.removeAttribute('disabled');
                    btn.classList.remove('opacity-50', 'cursor-not-allowed');
                }
            });
            
            if (buyNowButton) {
                if (!isAvailable || maxQuantity === 0) {
                    buyNowButton.setAttribute('disabled', 'disabled');
                    buyNowButton.classList.add('opacity-50', 'cursor-not-allowed');
                } else {
                    buyNowButton.removeAttribute('disabled');
                    buyNowButton.classList.remove('opacity-50', 'cursor-not-allowed');
                }
            }
        }
    }
    
    // Function to update stock notice display
    function updateStockNotice(productContainer, maxQuantity, isAvailable) {
        const selectedLocationCode = (localStorage.getItem('selectedLocationCode') || 'ALL').trim();
        const selectedLocationText = localStorage.getItem('selectedLocationText') || selectedLocationCode;
        
        // Remove existing notices
        const existingNotice = document.getElementById('location-availability-notice');
        const existingStockNotice = document.getElementById('location-stock-notice');
        if (existingNotice) existingNotice.remove();
        if (existingStockNotice) existingStockNotice.remove();
        
        // Find a good insertion point near the buy buttons
        const buyButtonsContainer = document.querySelector('.product-info__buy-buttons');
        if (!buyButtonsContainer) return;
        
        if (!isAvailable) {
            const noticeElement = document.createElement('div');
            noticeElement.id = 'location-availability-notice';
            noticeElement.style.cssText = 'color: #dc2626; font-size: 14px; margin-top: 8px; font-weight: 500; display: flex; align-items: center; gap: 6px;';
            noticeElement.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path d="M8 1a7 7 0 100 14A7 7 0 008 1zm0 10.5a.75.75 0 110-1.5.75.75 0 010 1.5zM8.75 4.75v4a.75.75 0 01-1.5 0v-4a.75.75 0 011.5 0z"/></svg> Not available in ' + selectedLocationText;
            buyButtonsContainer.appendChild(noticeElement);
        } else if (maxQuantity === 0) {
            const noticeElement = document.createElement('div');
            noticeElement.id = 'location-availability-notice';
            noticeElement.style.cssText = 'color: #dc2626; font-size: 14px; margin-top: 8px; font-weight: 500; display: flex; align-items: center; gap: 6px;';
            noticeElement.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path d="M8 1a7 7 0 100 14A7 7 0 008 1zm0 10.5a.75.75 0 110-1.5.75.75 0 010 1.5zM8.75 4.75v4a.75.75 0 01-1.5 0v-4a.75.75 0 011.5 0z"/></svg> Out of stock for this variant';
            buyButtonsContainer.appendChild(noticeElement);
        }
    }
    
    // Function to disable all add to cart buttons when no location is selected
    function disableAllAddToCartButtons() {
        // Disable all quick buy buttons on collection pages
        document.querySelectorAll('.product-card__quick-buy button').forEach(button => {
            button.setAttribute('disabled', 'disabled');
            button.classList.add('opacity-50', 'cursor-not-allowed');
            button.setAttribute('title', 'Please select a location first');
        });
        
        // Disable add to cart and buy now buttons on product pages
        const addToCartButtons = document.querySelectorAll(
            'buy-buttons button[type="submit"], button[type="submit"][form^="product-form"]'
        );
        const buyNowButton = document.querySelector('.shopify-payment-button button');
        
        addToCartButtons.forEach(btn => {
            btn.setAttribute('disabled', 'disabled');
            btn.classList.add('opacity-50', 'cursor-not-allowed');
        });
        
        // Add notification near the buy buttons
        const buyButtonsContainer = document.querySelector('.product-info__buy-buttons');
        if (buyButtonsContainer) {
            let notificationElement = document.getElementById('location-availability-notice');
            if (!notificationElement) {
                notificationElement = document.createElement('div');
                notificationElement.id = 'location-availability-notice';
                notificationElement.style.cssText = 'color: #dc2626; font-size: 14px; margin-top: 8px; font-weight: 500; display: flex; align-items: center; gap: 6px;';
                notificationElement.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path d="M8 1a7 7 0 100 14A7 7 0 008 1zm0 10.5a.75.75 0 110-1.5.75.75 0 010 1.5zM8.75 4.75v4a.75.75 0 01-1.5 0v-4a.75.75 0 011.5 0z"/></svg> Please select a location before purchasing';
                buyButtonsContainer.appendChild(notificationElement);
            }
        }
        
        if (buyNowButton) {
            buyNowButton.setAttribute('disabled', 'disabled');
            buyNowButton.classList.add('opacity-50', 'cursor-not-allowed');
        }
    }

    function getSelectedLocationText() {
        return localStorage.getItem('selectedLocationText') || localStorage.getItem('selectedLocationCode') || '';
    }

    function getProductTagsFromEvent(event) {
        const productCard = event.target.closest('.product-card');
        if (productCard && productCard.hasAttribute('data-tags')) {
            return productCard.getAttribute('data-tags');
        }
        const productContainer = event.target.closest('.product');
        if (productContainer && productContainer.hasAttribute('data-tags')) {
            return productContainer.getAttribute('data-tags');
        }
        return '';
    }

    function blockIfUnavailable(event) {
        const selectedCode = (localStorage.getItem('selectedLocationCode') || 'ALL').trim();
        // If no location selected, treat as unavailable (selection guard should already run)
        if (selectedCode === 'ALL' || selectedCode === '') return true;

        const tags = getProductTagsFromEvent(event);
        if (!tags) return false; // if no tags, don't block here (other guards may apply)

        const isAvailable = isProductAvailableInLocation(tags);
        if (!isAvailable) {
            event.preventDefault();
            event.stopPropagation();
            alert(`Product stock not available in ${getSelectedLocationText()}.`);
            return true;
        }
        return false;
    }

    // Add event listeners to all add to cart buttons to check location and availability
    document.addEventListener('click', function(event) {
        if (event.target.closest('button[type="submit"]') || 
            event.target.closest('button[data-shopify-payment-button]')) {
            // Require location selection
            if (isLocationSelectionRequired()) {
                event.preventDefault();
                event.stopPropagation();
                showFilterPopup();
                alert('Please select a location before adding to cart.');
                return false;
            }

            // Block if product is not available for selected location
            if (blockIfUnavailable(event)) {
                return false;
            }
            
            // Validate quantity for product page
            const productContainer = event.target.closest('.product') || document.querySelector('.product');
            if (productContainer) {
                const quantityInput = productContainer.querySelector('input[name="quantity"]');
                const requestedQuantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
                const validation = validateQuantity(productContainer, requestedQuantity);
                
                if (!validation.valid) {
                    event.preventDefault();
                    event.stopPropagation();
                    alert(validation.message);
                    
                    // If there's a max quantity, update the input
                    if (validation.maxQuantity && quantityInput) {
                        quantityInput.value = validation.maxQuantity;
                    }
                    return false;
                }
            }
        }
    }, true);
    
    // Intercept form submissions for product forms
    document.addEventListener('submit', function(event) {
        const form = event.target;
        if (form && form.hasAttribute('is') && form.getAttribute('is') === 'product-form') {
            // Require location selection
            if (isLocationSelectionRequired()) {
                event.preventDefault();
                event.stopPropagation();
                showFilterPopup();
                alert('Please select a location before adding to cart.');
                return false;
            }
            
            // Find product container
            const productContainer = document.querySelector('.product');
            if (productContainer) {
                const quantityInput = productContainer.querySelector('input[name="quantity"]');
                const requestedQuantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
                const validation = validateQuantity(productContainer, requestedQuantity);
                
                if (!validation.valid) {
                    event.preventDefault();
                    event.stopPropagation();
                    alert(validation.message);
                    
                    // If there's a max quantity, update the input
                    if (validation.maxQuantity && quantityInput) {
                        quantityInput.value = validation.maxQuantity;
                    }
                    return false;
                }
            }
        }
    }, true);
    
    // Monitor quantity input changes and validate against max
    document.addEventListener('change', function(event) {
        if (event.target.matches('input[name="quantity"]')) {
            const productContainer = event.target.closest('.product') || event.target.closest('.product-card');
            if (productContainer) {
                const maxQuantity = getMaxQuantityForProduct(productContainer);
                const currentValue = parseInt(event.target.value, 10) || 1;
                
                if (maxQuantity > 0 && currentValue > maxQuantity) {
                    event.target.value = maxQuantity;
                    const selectedLocationText = localStorage.getItem('selectedLocationText') || localStorage.getItem('selectedLocationCode');
                    alert(`Only ${maxQuantity} units available in ${selectedLocationText}. Quantity adjusted.`);
                }
            }
        }
    });
    
    // Run these checks immediately when the page loads
    updateAddToCartButtons();
    
    // Listen for variant changes on the product page to update stock warnings
    // Shopify themes typically update the form input[name="id"] when a variant changes
    const variantObserver = new MutationObserver(function(mutations) {
        let shouldUpdate = false;
        mutations.forEach(function(mutation) {
            // Watch for changes to hidden input[name="id"] (variant ID)
            if (mutation.type === 'attributes' && mutation.target.matches && 
                mutation.target.matches('input[name="id"]')) {
                shouldUpdate = true;
            }
            // Also watch for DOM changes that might indicate variant switch
            if (mutation.type === 'childList') {
                const target = mutation.target;
                if (target.closest && (target.closest('.product-info') || target.closest('buy-buttons'))) {
                    shouldUpdate = true;
                }
            }
        });
        if (shouldUpdate) {
            setTimeout(updateAddToCartButtons, 100);
        }
    });
    
    const productInfoEl = document.querySelector('.product-info');
    if (productInfoEl) {
        variantObserver.observe(productInfoEl, {
            attributes: true,
            childList: true,
            subtree: true,
            attributeFilter: ['value', 'disabled']
        });
    }
    
    // Also listen for Shopify's custom variant change event
    document.addEventListener('variant:changed', function() {
        setTimeout(updateAddToCartButtons, 100);
    });
});




















document.addEventListener('DOMContentLoaded', function() {
  // Filter predictive search results by selected location
  function filterPredictiveSearchResults() {
    const selectedLocationCode = localStorage.getItem('selectedLocationCode') || 'ALL';
    if (selectedLocationCode === 'ALL') return;

    const predictiveResults = document.querySelectorAll('.predictive-search-result[data-tags]');
    predictiveResults.forEach(result => {
      const tags = result.getAttribute('data-tags') ? result.getAttribute('data-tags').split(',') : [];
      if (!tags.includes(selectedLocationCode)) {
        result.style.display = 'none';
      } else {
        result.style.display = '';
      }
    });
  }

  // Observe the predictive search container for new results being loaded
  const predictiveSearchEl = document.querySelector('predictive-search');
  if (predictiveSearchEl) {
    const observer = new MutationObserver(function(mutations) {
      filterPredictiveSearchResults();
    });
    observer.observe(predictiveSearchEl, { childList: true, subtree: true });
  }
});

document.addEventListener('DOMContentLoaded', function() {
  // Fix for mobile filter button
  const mobileFilterButton = document.querySelector('.facets__floating-filter button');
  const facetsDrawer = document.getElementById('facets-drawer');
  
  if (mobileFilterButton && facetsDrawer) {
    mobileFilterButton.addEventListener('click', function(event) {
      event.preventDefault();
      facetsDrawer.open = true;
    });
  }
  
  // Make sure the drawer close button works
  const closeButtons = document.querySelectorAll('#facets-drawer [is="close-button"]');
  closeButtons.forEach(button => {
    button.addEventListener('click', function() {
      facetsDrawer.open = false;
    });
  });
});


document.addEventListener('DOMContentLoaded', function() {
  // Handle form submission
  const filterForms = document.querySelectorAll('form[action*="/collections/"]');
  const loadingSpinner = document.getElementById('loading-spinner');
  
  filterForms.forEach(form => {
    form.addEventListener('submit', function(event) {
      if (loadingSpinner) loadingSpinner.style.display = 'block';
    });
  });
  
  // Handle filter changes
  const filterInputs = document.querySelectorAll('.facets-vertical input[type="checkbox"], .facets-vertical input[type="radio"]');
  filterInputs.forEach(input => {
    input.addEventListener('change', function() {
      const submitButton = this.closest('form').querySelector('button[type="submit"]');
      if (submitButton) submitButton.click();
    });
  });
});

